import Highcharts from 'highcharts';

export function getHoveredCurvePoints(hoveredPoint: Highcharts.Point): { windSpeed: number; points: Highcharts.Point[] } {
  const hoveredWindSpeed = hoveredPoint.x;
  const distance = (p: Highcharts.Point) => Math.abs(p.x - hoveredWindSpeed);
  const curvePoints = hoveredPoint.series.chart.series
    .filter(s => s.visible && s.type !== 'scatter' && s.points?.length)
    .map(s => s.points.reduce((nearest, p) => distance(p) < distance(nearest) ? p : nearest));
  const nearestCurvePoint = curvePoints.reduce<Highcharts.Point | null>(
    (nearest, p) => !nearest || distance(p) < distance(nearest) ? p : nearest,
    null,
  );
  return {
    windSpeed: nearestCurvePoint?.x ?? hoveredWindSpeed,
    points: hoveredPoint.series.type === 'scatter' ? [...curvePoints, hoveredPoint] : curvePoints,
  };
}
